import { render, staticRenderFns } from "./resumo-habilitador.vue?vue&type=template&id=f06866ae&scoped=true"
import script from "./resumo-habilitador.vue?vue&type=script&lang=js"
export * from "./resumo-habilitador.vue?vue&type=script&lang=js"
import style0 from "./resumo-habilitador.vue?vue&type=style&index=0&id=f06866ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06866ae",
  null
  
)

export default component.exports